import { mapGetters, mapState } from 'vuex'

export default
{
	computed:
	{
		...mapState
		({
			employee: state => state.authUser,
		}),

		...mapGetters
		([
			'employeeAuthenticated',
			'employeeFullName',
			'employeeInitials',
			'employeeIsSales',
			'employeeUsername',
		]),

		employeeIsAdmin()
		{
			return this.employee?.employee_is_admin === true
		},
	},
}